// The loaded library in the browser. Screens re-draw when it changes.
import { useSyncExternalStore } from "react";
import { NATURAL } from "../audio/voice/voice";
import { LIBRARY_VERSION, type Asset, type Library } from "../model/library";
import type { VoiceSettings } from "../model/voice";

let lib: Library = { version: LIBRARY_VERSION, assets: [] };
const listeners = new Set<() => void>();

export const getLibrary = () => lib;
export function setLibrary(next: Library) {
  lib = next;
  listeners.forEach(l => l());
}
export const putAsset = (a: Asset) =>
  setLibrary({ ...lib, assets: lib.assets.some(x => x.id === a.id) ? lib.assets.map(x => (x.id === a.id ? a : x)) : [...lib.assets, a] });

export const useLibrary = (): Library => useSyncExternalStore(l => (listeners.add(l), () => listeners.delete(l)), () => lib);

// Filters only apply to lines you record; AI voices play as generated.
export const voiceOf = (l: Library) => (speaker: string): VoiceSettings => {
  const a = l.assets.find(x => x.id === speaker);
  return a?.voiceMode === "ai" ? NATURAL : a?.voice ?? NATURAL;
};
export const dropAsset = (id: string) => setLibrary({ ...lib, assets: lib.assets.filter(x => x.id !== id) });
